export { default } from "./FilterSlide";
